export enum ResponseStatusEnum {
    badRequest = 400,
    created = 201,
    conflict = 409,
    forbidden = 403,
    internalServerError = 500,
    notFound = 404,
    ok = 200,
    redirect = 302,
}
